<template>
  <!-- 添加标签的模态框 -->
  <el-dialog :visible.sync="dialogAdd" :before-close="cancelTag">
    <el-form :model="form">
      <el-form-item>
        <span>*</span>
        <el-date-picker v-model="form.year" @change="choiceYear" type="year" placeholder="选择年">
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <span>*</span>
        <el-select
          v-model="form.quarter"
          @change="choiceQuarter"
          placeholder="选择季度"
        >
          <el-option
            v-for="(item, index) in quarter"
            :key="index"
            :label="item.name"
            :value="index"
          ></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="cancelTag">取 消</el-button>
      <el-button :disabled="formSelect" type="primary" @click="checkTag"
        >添 加</el-button
      >
    </div>
  </el-dialog>
</template>
<script>
export default {
  props: { dialogAdd: Boolean },
  data() {
    return {
      dialogFormVisible: false,
      form: { year: '',quarter:'',position:'yearQuarter',orderNum:'',status:1, },
      quarter: [
        { name: "第一季度" ,value:'spring'},
        { name: "第二季度" ,value:'summer'},
        { name: "第三季度" ,value:'autumn'},
        { name: "第四季度" ,value:'winter'}
      ],
      typeTagList: [],
      secondLevel: [],
      addAreaType: false,
      formSelect: true
    };
  },
  created() {},
  mounted() {},
  methods: {
    selectChanged() {},
    choiceQuarter(index) {
      this.formSelect = false;
      this.form.orderNum=(index+1).toString()
      this.form.subTitle=this.quarter[index].value
    },
    choiceYear(id){
      this.form.title=this.$dtime(id).format('YYYY')
    },
    cancelTag() {
      this.$emit("cancelTag");
    },
    checkTag() {
      this.$emit("checkTag", this.form);
    }
  }
};
</script>
<style lang="scss" scoped>
/deep/ .el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 100% !important;
}
/deep/ .el-form-item__content {
  display: flex;
  > span {
    color: red;
    margin: 0 10px;
  }
}
// elForm 弹出框的样式
/deep/ .el-dialog {
  width: 31%;
  box-shadow: $boxshadow;
  border-radius: 4px;
  .el-form {
    display: flex;
    justify-content: space-around;
  }
  .el-dialog__footer {
    padding: 10px 25% 20px;
    .dialog-footer {
      height: 28px;
      display: flex;
      justify-content: space-around;
      .el-button--default:hover {
        background: $base-color;
      }
      .el-button--default {
        border-radius: 100px;
        border: 1px solid $schoolTagBorder;
        padding: 4px 24px;
        span {
          font-size: 12px;
          color: $schoolTagColor;
        }
      }
      .el-button--primary {
        border-radius: 100px;
        background: $pageViewSmall;
        border: 1px solid $pageViewSmall;
        padding: 4px 24px;
        span {
          font-size: 12px;
          color: $base-color;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/admin/university/components/DialogAdd.vue